import { Injectable, Injector } from '@angular/core';

import { DateService } from './date.service';
import { UtilsService } from './utils.service';
import type { TReportOptions, TTimestamp } from '@shared/models';
import { Constants } from '@shared/models';
const DateTimeFormats = Constants.DateTimeFormats;

@Injectable({
    'providedIn': 'root'
})
export class BaseReportService {
    protected DateTimeFormats;
    protected utilsService: UtilsService;
    protected dateService: DateService;
    protected options!: TReportOptions;

    // private utilsService: UtilsService)
    constructor(injector: Injector) {
        this.utilsService = injector.get(UtilsService);
        this.dateService = injector.get(DateService);
    }

    protected initialize(reportOptions: TReportOptions) {
        this.options = reportOptions;
    }

    protected addSummaryRow(columns: string[], allRows: any[]) {
        const rowInfo = this.buildRowInfo(columns, 'summary');
        allRows.push(rowInfo);
    }

    public buildRowInfo(columnValues: string[], type: string, myClass = '') {
        const values: any[] = [];

        columnValues.forEach((value) => {
            const obj = { 'value': value };
            values.push(obj);
        });
        const rowInfo = { 'cells': values, 'type': type, 'myClass': myClass };
        return rowInfo;
    }

    public getBlankLine() {
        const blankLine = this.buildRowInfo([' '], 'summary');
        return blankLine;
    }

    public truncateWithEllipsis(message: string, maxLen = 100) {
        if (!message) {
            return null;
        }
        let newMessage = message.substr(0, maxLen - 3);
        newMessage += '...';
        return newMessage;
    }

    // public sortData(rows: any[], option: TReportOptions) {
    //     const count = option.selectedReport.sortColumns.length;
    //     const sortColumn1 = (count > 0 ? option.selectedReport.sortColumns[0] : null);
    //     // const sortColumn2 = (count > 1 ? option.selectedReport.sortColumns[1] : null);

    //     switch (count) {
    //         case 1:
    //             rows.sort((a, b) => {
    //                 const col1 = a.cells[sortColumn1];
    //                 const col2 = b.cells[sortColumn1];

    //                 if (col1 < col2) {
    //                     return -1;
    //                 } else if (col1 > col2) {
    //                     return 1;
    //                 } else {
    //                     return 0;
    //                 }
    //             });
    //             break;

    //         case 2:
    //             // console.error('2 column sort not implemented yet.');
    //             break;
    //     }
    //     return rows;
    // }

    public convertSummaryDate(summaryDate: string, format: string = DateTimeFormats.MediumDate): string {
        const timestamp = this.dateService.parse(summaryDate, DateTimeFormats.ShortDate);
        const date = this.formatDateTime(timestamp, format);
        return date;
    }

    public formatDate(timestamp: TTimestamp): string {
        return this.dateService.formatTimestamp(timestamp, DateTimeFormats.LongDate);
    }

    public formatTime(timestamp: TTimestamp, format: string = DateTimeFormats.ShortTime): string {
        return this.dateService.formatTimestamp(timestamp, format);
    }

    public formatDateTime(timestamp: TTimestamp, format: string = DateTimeFormats.MediumDate): string {
        return this.dateService.formatTimestamp(timestamp, format);
    }

    protected formatDuration(start: TTimestamp, end: TTimestamp): string {
        return this.dateService.formatDuration(start, end);
    }

    // public formatTimeAndDuration(start: TTimestamp, end: TTimestamp): string {
    // return this.dateService.formatTimeAndDuration(start, end);
    // const timeStart = this.formatTime(start);
    // const timeEnd = this.formatTime(end);
    // const duration = this.formatDuration(start, end);
    // const str = timeStart + ' (+' + duration + ')';
    // return str;
    // }
}
